export default __webpack_public_path__ + "static/media/cubo.d29b6105.svg";